var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.973,
    height: 11.973,
    viewBox: "0 0 11.973 11.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-293.441 -211)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(293.441 211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.71,0V.855h9.408v9.408h.855V0H1.71ZM0,1.71V11.973H10.263V1.71H0Zm.855.855H9.408v8.552H.855Z",
    transform: "translate(0 0)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(295.208 214.594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.761.5H0v-1H6.761Z",
    transform: "translate(0 3.38)",
    fill: "#b5b5b5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.7d02c3f82ec06e0cf9d2dfc5a34ec76c.svg";
export { ForwardRef as ReactComponent };